/** Fetch short-lived TURN credentials from bootstrap endpoint (H3). */

import type { BootstrapDocument } from "@veto/protocol";
import { DEFAULT_BOOTSTRAP } from "./bootstrap";
import { iceServersFromBootstrap } from "./webrtc";

export async function fetchTurnCredentials(
  bootstrap: BootstrapDocument = DEFAULT_BOOTSTRAP,
): Promise<{ username: string; credential: string } | null> {
  const endpoint = bootstrap.turn[0]?.credential_endpoint;
  if (!endpoint) return null;
  try {
    const res = await fetch(endpoint, { cache: "no-store" });
    if (!res.ok) return null;
    const json = (await res.json()) as { username?: string; credential?: string };
    if (!json.username || !json.credential) return null;
    return { username: json.username, credential: json.credential };
  } catch {
    return null;
  }
}

export async function iceServersWithMintedTurn(
  bootstrap: BootstrapDocument = DEFAULT_BOOTSTRAP,
): Promise<RTCIceServer[]> {
  const creds = await fetchTurnCredentials(bootstrap);
  return iceServersFromBootstrap(bootstrap, creds ?? undefined);
}
